// extracted by mini-css-extract-plugin
module.exports = {"shippingAndReturnsButton":"ShippingAndReturnsLegacy_shippingAndReturnsButton__KmNFx","subtitle":"ShippingAndReturnsLegacy_subtitle__N_8FQ"};